'use client'

import { useState, useCallback } from 'react'

interface UseCellEditingOrchestrationProps {
  data: any[]
  setData: React.Dispatch<React.SetStateAction<any[]>>
  onCellUpdate?: (rowId: string, colId: string, value: string) => Promise<void>
}

export function useCellEditingOrchestration({
  data,
  setData,
  onCellUpdate,
}: UseCellEditingOrchestrationProps) {
  const [isUpdating, setIsUpdating] = useState(false)

  const handleConfirmCellEdit = useCallback(async (rowId: string, colId: string, value: string) => {
    setIsUpdating(true)

    try {
      setData(prev => prev.map(row => {
        if (String(row.id) === String(rowId)) {
          return { ...row, [colId]: value }
        }
        return row
      }))

      if (onCellUpdate) {
        await onCellUpdate(rowId, colId, value)
      }
    } catch (error) {
      console.error('Error updating cell:', error)
      throw error
    } finally {
      setIsUpdating(false)
    }
  }, [setData, onCellUpdate])

  return {
    handleConfirmCellEdit,
    isUpdating,
  }
}
